
import axios from 'axios'


export default {

  async sendSeatPrint(context, payload) {
    const url = `/reportes/report-seats`;
    // No se captura el error a propósito: el componente necesita enterarse
    // para poder avisarle al usuario en vez de fallar en silencio.
    return await axios.post(url, payload);
  },
  async listSeatAccount(context) {
    const url = `/reportes/lists-seats`;
    const response = await axios.get(url);
    sessionStorage.setItem('seatLists', JSON.stringify(response.data));
    context.commit('setSeatListsMutation', {
      seatLists: response.data,
    });
    return response
  },
  async tryListSeatAccount(context) {
    let seats = null;
    try {
      seats = JSON.parse(sessionStorage.getItem('seatLists'));
    } catch (error) {
      // sessionStorage con json corrupto: se ignora y se vuelve a pedir al API
      seats = null;
    }

    if (!seats) {
      const response = await context.dispatch('listSeatAccount');
      return response ? response.data : null
    }

    context.commit('setSeatListsMutation', {
      seatLists: seats,
    });
    return seats
  },
  async searchCustomers(context, payload) {
    try {
      const response = await axios.get(payload);
      context.commit('setCustomerLists', {
        customersLists: response.data
      });
      return response
    } catch (error) {
      console.log(error)

    }
  },
  async pagesCustomers(context, payload) {
    try {
      const response = await axios.get(payload);

      sessionStorage.setItem('customerLists', JSON.stringify(response.data));
   await context.commit('setCustomerLists', {
        customersLists: response.data
      });
      return response
    } catch (error) {
      console.log(error)

    }
  }


}
